var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline-sections"},_vm._l((_vm.timelines),function(timeline){return _c(timeline.componentName,{key:timeline.key,tag:"component",staticClass:"timeline-sections__section",attrs:{"treatment":_vm.treatment,"is-active":timeline.isActive,"can-open-section":timeline.canOpen}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }